import { render } from "./ListPaymentsRequests.vue?vue&type=template&id=f98ea87c"
import script from "./ListPaymentsRequests.vue?vue&type=script&lang=js"
export * from "./ListPaymentsRequests.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__